import {h, Component} from 'preact';
import {connect} from 'preact-redux';

class UnreadMessageIndicatorChatBody extends Component
{
    constructor()
    {
        super();
        this.handleClick = this.handleClick.bind(this);
    }

    render() {
        const unreadCount = this.props.unreadCount;
        return (
            <div class='unread-message-indicator-chat-body-wrapper'>
                <span class='unread-message-indicator-chat-body pointer' onClick={this.handleClick}>
                    <span class='unread-message-indicator-chat-body__arrow icon icon-arrow-down3'></span>
                    <span class='unread-message-indicator-chat-body__count'>{unreadCount}</span>
                </span>
            </div>
        );
    }

    handleClick()
    {
        this.props.scrollToBottomOfChatBody();
    }

}

export default UnreadMessageIndicatorChatBody;



// WEBPACK FOOTER //
// ./routes/Chat/Chat/UnreadMessageIndicatorChatBody.js